// EQ Bank CSV (Canadian online chequing). Mirrors load_eqbank_csv.
//
// Headers: Date, Description, Out, In, Balance. Exactly one of Out or
// In is populated per row. Currency is CAD. Project convention:
// positive = expense, negative = income — so Out → +, In → -.

import {
  type Transaction,
  newTransaction,
  makeId,
  parseAmount,
  parseDate,
  normalizeVendor,
  isInterPortalTransfer,
} from "../common.js";
import { parseCsv, toDictRows, findHeaderIndex } from "../csv.js";

export async function loadEqbankCsv(
  text: string,
  filename: string,
): Promise<Transaction[]> {
  const rows = parseCsv(text);
  const headerIdx = findHeaderIndex(rows, ["Date", "Description"]);
  if (headerIdx < 0 || headerIdx >= rows.length - 1) return [];
  const dicts = toDictRows(rows[headerIdx], rows.slice(headerIdx + 1));

  const out: Transaction[] = [];
  for (const row of dicts) {
    const date = parseDate(row["Date"] || "");
    if (!date) continue;
    const outAmt = parseAmount(row["Out"] || "0");
    const inAmt = parseAmount(row["In"] || "0");
    let amount: number;
    if (outAmt) amount = outAmt;
    else if (inAmt) amount = -inAmt;
    else continue;
    const description = (row["Description"] || "").trim().replace(/^"|"$/g, "");
    if (isInterPortalTransfer(description)) continue;

    const id = await makeId("eqbank", "EQ", date, amount, description);
    out.push(
      newTransaction({
        id,
        date,
        vendor_raw: description,
        vendor_key: normalizeVendor(description) || "eqbank",
        amount: Math.round(amount * 100) / 100,
        portal: "eqbank",
        account: "EQ",
        account_kind: "debit",
        source_file: filename,
        raw: row,
      }),
    );
  }
  return out;
}
